import * as FeatherIcons from 'vue-feather-icons';

export default {
    items: [
        {
            name: 'Dashboard',
            type: 'dashboard',
            route: 'dashboard',
            iconClasses: ['font-icon', 'font-icon-dashboard'],
            iconClass: 'material-icons',
            iconName: 'dashboard',
            color: 'navy',
            group: 'general',
            iconComponent: FeatherIcons.GridIcon,
        },
        {
            name: 'Content',
            children: [
                { name: 'Pages', route: 'pages', type: 'page' },
                { name: 'Panel library', route: 'panels', type: 'panel' },
            ],
            iconClass: 'material-icons',
            iconName: 'content_copy',
            color: 'navy',
            group: 'general',
            iconComponent: FeatherIcons.LayersIcon,
        },
        {
            name: 'Assets',
            route: 'assets',
            type: 'asset',
            iconClass: 'material-icons',
            iconName: 'photo_album',
            color: 'navy',
            group: 'general',
            iconComponent: FeatherIcons.ImageIcon,
        },
        {
            name: 'News',
            route: 'news_posts',
            type: 'news_post',
            // children: [
            //     { name: 'Posts', route: 'news_posts', type: 'news_post' },
            //     { name: 'Categories', route: 'news_categories', type: 'news_category' },
            // ],
            iconClass: 'material-icons',
            iconName: 'perm_media',
            color: 'navy',
            group: 'general',
            iconComponent: FeatherIcons.FileTextIcon,
        },
        {
            name: 'Videos',
            route: 'videos',
            type: 'video',
            iconClass: 'material-icons',
            iconName: 'video_library',
            color: 'navy',
            group: 'general',
            iconComponent: FeatherIcons.VideoIcon,
        },
        {
            name: 'FAQs',
            route: 'faqs',
            type: 'faq',
            iconClass: 'material-icons',
            iconName: 'help_outline',
            color: 'navy',
            group: 'general',
            iconComponent: FeatherIcons.FileTextIcon,
        },
        {
            name: 'Products',
            children: [
                { name: 'Products', route: 'products', type: 'product' },
                { name: 'Categories', route: 'categories', type: 'category' },
                { name: 'Brands', route: 'brands', type: 'brand' },
            ],
            iconClass: 'material-icons',
            iconName: 'store',
            color: 'navy',
            group: 'products',
            iconComponent: FeatherIcons.ShoppingCartIcon,
        },
        {
            name: 'Stockists',
            type: 'stockist',
            route: 'stockists',
            iconClass: 'material-icons',
            iconName: 'store',
            color: 'navy',
            group: 'products',
            iconComponent: FeatherIcons.CheckCircleIcon,
        },
        {
            name: 'Projects',
            route: 'projects',
            type: 'project',
            iconClass: 'material-icons',
            iconName: 'perm_media',
            color: 'navy',
            group: 'projects',
            iconComponent: FeatherIcons.CheckCircleIcon,
        },
        {
            name: 'Enquiries',
            children: [
                { name: 'Enquiries', route: 'enquiries', type: 'enquiry' },
                { name: 'Subscribers', route: 'subscribers', type: 'subscriber' },
            ],
            iconClass: 'material-icons',
            iconName: 'forum',
            color: 'navy',
            group: 'customer',
            iconComponent: FeatherIcons.MessageSquareIcon,
        },
        {
            name: 'Accounts',
            children: [
                { name: 'Users', route: 'users', type: 'user' },
                { name: 'Roles', route: 'roles', type: 'role' },
            ],
            iconClass: 'material-icons',
            iconName: 'account_box',
            color: 'navy',
            group: 'settings',
            iconComponent: FeatherIcons.LockIcon,
        },
        {
            name: 'Settings',
            children: [
                { name: 'Settings', route: 'settings', type: 'setting' },
                { name: 'Redirect URLs', route: 'redirect_urls', type: 'redirect_url' },
            ],
            iconClass: 'material-icons',
            iconName: 'settings',
            color: 'navy',
            group: 'settings',
            iconComponent: FeatherIcons.SettingsIcon,
        },
    ],
    defaultItem: 'Content',
}
